import { Pill, PillProps } from '@/components/ui/Pill';
import { cn } from '@/lib/helpers/utils';
import React from 'react';

export interface DaysLeftToApplyPillProps extends PillProps {
  daysLeft: number;
}

export const DaysLeftToApplyPill = ({
  daysLeft,
  size = 'sm',
  appearance = 'warning',
  className,
  children,
  ...props
}: DaysLeftToApplyPillProps) => {
  let daysLeftClassName: string = '';
  if (daysLeft > 0) {
    if (daysLeft > 1) {
      daysLeftClassName = 'bg-warning-200 border-warning-200 text-foregound';
    }
  }
  if (daysLeft <= 0) {
    appearance = 'danger';
  }
  return (
    <Pill size={size} appearance={appearance} className={cn('px-3 space-x-1', daysLeftClassName, className)} {...props}>
      {children}
    </Pill>
  );
};
